// Import react elements
import React, { useEffect, useRef, useState } from 'react';

// Import CSS for this component
import './ImageLoader.css';



// Export the ImageLoader component
export const ImageLoader = ({ src, alt, className, wrapperCSS, imageLoaderImageCSS }) => {

    
    //const [isLoading, setIsLoading] = useState(true);

    // Track whether is should load
    const [shouldLoad, setShouldLoad] = useState(false);

    // Track loading state
    const [hasLoaded, setHasLoaded] = useState(false);

    // Track the image source
    const [imageSrc, setImageSrc] = useState("");

    // Fallback image
    const fallbackImage = '/images/placeholder.png';

    // Referrence to track DOM element
    const wrapperRef = useRef(null);


/*
    // useEffect to update imageSrc when src prop changes
    useEffect(() => {

        // When the src changes, start loading again
        setImageSrc(src);

        // Set loading back to true for the new image
        setIsLoading(true);

        // Only run this when src prop changes
    }, [src]); 

    // When the image loads successfully
    const handleImageLoad = () => {

        setIsLoading(false);

    };

    // When the image fails to load
    const handleImageError = () => {

        setImageSrc(fallbackImage);

        setIsLoading(false);

    };
*/

    // useEffect to update imageSrc when src prop changes
    useEffect(() => {

        // Store a stable reference to the observed element at the time this effect runs
        const targetElement = wrapperRef.current;

        // Create a new IntersectionObserver instance and assign it to the 'observer' constant
        const observer = new IntersectionObserver (

            // This is the callback function that is triggered when the target intersects with the viewport
            ([entry]) => {

                // Start loading once the element enters the viewport (or root margin).
                if (entry.isIntersecting) {

                    // Trigger the effect to load data or content when the target is fully visible
                    setShouldLoad(true);

                    // Disconnect the observer since we only want to load once and stop observing
                    observer.disconnect();

                }

            },

            // Observer options
            {
                // 'null' means use the browser viewport as the container to observe visibility within
                root: null,

                // Start observing 300px before the element enters the viewport
                rootMargin: '300px',

                // Trigger the callback when at least 1% of the target is visible
                threshold: 0.01,
            }

            );

            // If the wrapperRef (a React ref to a DOM element) is currently assigned
            if (targetElement) {

                // Start observing the element referenced by wrapperRef
                observer.observe(targetElement);

            }

            // Return a cleanup function to stop observing when the component unmounts or dependencies change
            return () => {

                // Check again if the wrapperRef is still assigned
                if (targetElement) {

                    // Stop observing the DOM element to prevent memory leaks
                    observer.unobserve(targetElement);

                }

            };

    }, []);



    // useEffect to update imageSrc when src prop or 'shouldLoad' changes
    useEffect(() => {

        // Check if the image should load
        if (shouldLoad) {

            // It should so set the img src prop
            setImageSrc(src);

            // Reset loaded state for the current src.
            setHasLoaded(false);

        }

    // Run when shouldLoad or image src changes
    }, [shouldLoad, src]);



  // When the image loads successfully - mark it as loaded
  const handleLoad = () => setHasLoaded(true);

  

  // When the image fails to load
  const handleError = () => {

    // Use the fallback image
    setImageSrc(fallbackImage);

    // Mark it as loaded
    setHasLoaded(true);

  };



    return (

        <div className={wrapperCSS ? wrapperCSS : "image-loader__wrapper"} ref={wrapperRef}>

            {shouldLoad && !hasLoaded && (

                <div className="image-loader__spinner"></div>

            )}

            {imageSrc && (

                <img
                src={imageSrc}
                alt={alt}
                className={`${className} ${imageLoaderImageCSS ? imageLoaderImageCSS : 'image-loader__image'} ${!hasLoaded ? 'image-loader__image--hidden' : ''}`}
                onLoad={handleLoad}
                onError={handleError}
                />

            )}

        </div>

  );

};
